<div class="sh-progress-steps">
    <div class="sh-progress-steps__line">
        <!-- Processing steps -->
        @for (step of processingProgress.steps; track step.name) {
            @if (!(step.optional && step.status === processingStatus.SKIPPED)) {
                <div class="sh-progress-steps__step">
                    <div [class]="step.statusClass" [title]="'processing-progress-list.status.' + step.status | translate"></div>

                    <span [class]="step.labelClass">
                        {{ "processing-progress-list.steps." + step.name | translate }}
                    </span>
                </div>
            }
        }
        <!-- Completed step -->
        <div class="sh-progress-steps__step">
            <div class="sh-progress-steps__step">
                <div [class]="processingProgress.statusClass" [title]="'processing-progress-list.status.' + processingProgress.status | translate"></div>

                <span [class]="processingProgress.labelClass">
                    {{ "processing-progress-list.steps.complete" | translate }}
                </span>
            </div>
        </div>
    </div>
</div>
